<template>
    <div>
        <navigation-bar Back Bell/>
        <category-content class="main">
            <category-header title="品牌推薦"/>
            <item-grid height="136px">
                <store-item :list="brandReferenceList" :param="{type: 'brand'}"/>
            </item-grid>

            <category-header :to="{name: 'MyStore'}" class="mt-5" v-if="isLogin" title="所有店家"/>
            <item-grid height="136px" v-if="isLogin">
                <store-item :to="{name: 'StoreInfo'}" :list="myAddStoreList"/>
            </item-grid>

            <category-header class="mt-5" title="快來串門子"/>
            <div class="multiple-column">
                    <store-item :to="{name: 'StoreInfo'}" :list="storeList"/>
            </div>
            <el-row type="flex" justify="center">
                <el-col :span="6" class="text-center">
                    <el-button type="text" @click="$router.push({ name: 'Visit'})">
                        <img src="@/assets/images/more.svg" alt="更多" style="width: 70px;">
                    </el-button>
                </el-col>
            </el-row>
        </category-content>
        <category-content class="pb-0" v-if="showHidden">
            <category-header title="好友串門子"/>
        </category-content>
        <category-content v-for="(item, index) in friendlyStoreList" :key="index" class="pt-0"  v-show="showHidden">
            <div class="article">
                <el-image :src="item.contentImage" fit="cover"></el-image>
                <p class="title">{{item.title}}</p>
                <p class="description">{{item.content}}</p>
            </div>
            <item-grid>
                <ex-store-item :to="{name: 'StoreInfo'}" v-for="o in 6" :key="o" />
            </item-grid>
        </category-content>

        <infinite-loading @infinite="setupDataScroll" spinner="waveDots" v-if="showHidden">
            <div slot="no-more">沒有更多資料</div>
            <span slot="no-results"/>
        </infinite-loading>

        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    import CategoryContent from '@/components/category/Content.vue';
    import CategoryHeader from '@/components/category/Header.vue';
    import ItemGrid from '@/components/category/ItemGrid.vue';
    import ExStoreItem from '@/components/category/ExStoreItem.vue';
    import StoreItem from '@/components/category/StoreItem.vue';

    export default {
        name: "BrandWall",
        components: {
            CategoryHeader,
            CategoryContent,
            ExStoreItem,
            StoreItem,
            ItemGrid
        },
        data() {
            return {
                isLoading: false,
                isLogin: this.$auth.isAdminLogin(),
                brandReferenceList: [],
                myAddStoreList: [],
                storeList: [],
                friendlyStoreList: [],

                pageSize: 10,
                currentPage: 0,
                showHidden: false,
                lng: 0,
                lat: 0,
            }
        },
        created() {
            this.setupData();
        },
        mounted() {

        },
        methods: {
            setupData: function () {
                //推薦店家
                this.$http.fetch`OinBrandReferenceList${{}}
                ${json => {
                    this.brandReferenceList = json.data;
                }}`;

                //我的店家
                // if (this.isLogin) {
                //     //先撈附近店家-最近店家來顯示
                //     this.$http.fetchWithAuth`AddStoreList${{}}
                //     ${json => {
                //         this.myAddStoreList = json.data;
                //     }}`;
                // }

                //快來串門子
                let self = this;
                this.isLoading = true;
                let onSuccess = function(position) {
                    self.lng = position.coords.longitude;
                    self.lat = position.coords.latitude;

                    self.getStoreList(1);
                    self.getStoreList(2);
                };
                let onError = function(error) {
                    self.lng = 0;
                    self.lat = 0;
                    self.getStoreList(1);
                    self.getStoreList(2);
                    self.$public.showNotify("code: "+error.code+", message: "+error.message+"。無法定位GPS", false, 3000)
                };

                self.$public.getGpsLocation(onSuccess, onError);

            },
            getStoreList(searchType){
                let self = this;
                this.isLoading = true;
                self.$http.fetch`StoreList${{
                    searchType: searchType,
                    offset: 0,
                    pageSize:searchType===1?12:0,
                    lng: self.lng,
                    lat: self.lat,
                }} ${json => {
                    if(searchType === 1){
                        self.storeList = json.data;
                    } else if (searchType === 2) {
                        self.myAddStoreList = json.data;
                    }
                    self.isLoading = false;
                }}`;
            },
            setupDataScroll: function ($state) {
                //好友串門子
                this.isLoading = true;
                this.$http.fetch`OinFriendlyList${{
                    offset: this.currentPage,
                }}
                ${json => {
                    if (json.data.length >= this.pageSize) {
                        this.currentPage++;
                        this.friendlyStoreList.push(...json.data);
                        $state.loaded();
                    } else {
                        this.currentPage++;
                        this.friendlyStoreList.push(...json.data);
                        $state.complete();
                    }
                    this.isLoading = false;
                }}`;
            },
        }
    }
</script>

<style lang="less" scoped>

    .list-header{
        margin-bottom: 10px;
    }
    .multiple-column {
        padding: 0 20px;
        > div{/*套完程式後會多一層div*/
            display: flex;
            flex-wrap: wrap;
            justify-content:space-between;
        }
    }

    .avatar-block {
        border: 1px solid rgba(212, 213, 213, 1);
        background: #fff;
        width: 85px;
        height: 85px;
        border-radius: 10px;
    }

    .article {
        padding: 20px;
        padding-top: 10px;

        .cover {
            width: 100%;
            height: 183px;
            background: rgb(246, 246, 246);
            margin-bottom: 10px
        }

        .title {
            font-size: 20px;
            color: rgb(114, 113, 113)
        }

        .description {
            font-size: 16px;
            color: rgb(159, 160, 160);
            margin-bottom: 0px;
        }
    }

</style>